// extracted by mini-css-extract-plugin
module.exports = {"componentsPasswordVerifyModal":"styles_componentsPasswordVerifyModal__2x6Q0","grid":"styles_grid__dMqiu","active":"styles_active__ttlrV"};